import React from 'react';
import {ArrowBack} from 'material-ui-icons';
import './Header.css';

export default function Header({
	title,
	onBackPress,
	Icon,
	cta,
	rightButton,
	colored,
}) {
	return (
		<div className={`headerWrapper ${cta || colored ? 'colored' : ''}`}>
			<div className={`headerContainer ${cta ? 'bordered' : ''}`}>
				<div onClick={onBackPress}>{Icon ? Icon : <ArrowBack />}</div>

				<h2 className='headerTitle'>{title}</h2>
				{rightButton && rightButton}
			</div>
			{cta && <div className='headerCta'>{cta}</div>}
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/Header.js